import _last from "lodash/last";
import _find from "lodash/find";

export const urlParse = () => {
    "ngInject";
    return (url) => url.replace(/\/api/i, "");
};

export const getObjectId = () => {
    "ngInject";
    return (url) => _last(url.replace(/\/$/, "").split("/"));
};

export const getObjectByUrl = () => {
    "ngInject";
    return (url, collection, prop) => {
        let item = _find(collection, (item) => item.url === url);
        return item ? item[prop] : "";
    };
};

export const getObjectByKey = () => {
    "ngInject";
    return (key, collection) => {
        return collection[key] || "";
    };
};

export const getObjectByKeyValue = () => {
    "ngInject";
    return (value, collection, key, prop) => {
        let item = _find(collection, (item) => item[key] === value);
        return item ? item[prop] : "";
    };
};


// WEBPACK FOOTER //
// ./sources/filters/urlParse.js